import { useContext } from 'react';
import { AuthContext } from '@streamster/shared/screens/auth/auth.utils';

export function useIsBusinessUser() {
  const { webAuth } = useContext(AuthContext);

  return Boolean(webAuth?.business);
}
